<template>
  <div :class="$style.card" @click.prevent="onClick">
    <div :class="$style.header">
      <div :class="$style.profile">
        <PImage
          :image-object="item.thumbnail"
          sizes="xs:32px"
          :class="$style.thumbnail"
        />
        <RichText :text-params="item.info" :class="$style.info" />
      </div>

      <img
        src="@/assets/icons/socials/twitter-icon-blue.svg"
        :class="$style.icon"
      />
    </div>
    <RichText :text-params="item.content" />
  </div>
</template>

<script>
import RichText from '~/components/RichText'

export default {
  name: 'TwitterCard',
  components: { RichText },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClick(e) {
      if (e.target.href) {
        return window.open(e.target.href, '_blank')
      } else if (this.item.link && this.item.link.url) {
        return window.open(this.item.link.url, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" module>
.card {
  padding: 24px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.thumbnail {
  width: 32px;
  height: 32px;
  margin-right: 16px;
  border-radius: 16px;
}

.profile {
  display: flex;
  align-items: center;
  width: 100%;
}
.icon {
  width: 22px;
  height: 22px;
}
.info {
  color: $gray-600;
  strong {
    @include typo-body;
    color: $gray-800;
  }
}
</style>
